import script from "./RenewalSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewalSuccess.vue?vue&type=script&setup=true&lang=js"

import "./RenewalSuccess.vue?vue&type=style&index=0&id=4dac2e09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dac2e09"]])

export default __exports__